<ng-container *ngIf="reusableContent.length > 0">
  <digital-platform-dynamic-content-wrapper
    *ngFor="let content of reusableContent"
    [config]="content"
  ></digital-platform-dynamic-content-wrapper>
</ng-container>
